import React, { useState } from "react";

const VIDEO_ID = "qw6FWuaucNc";
export const VIDEO_TITLE = "LiquidSpace platform overview";
const EMBED_URL = `https://www.youtube.com/embed/${VIDEO_ID}?autoplay=1&rel=0&modestbranding=1&playsinline=1`;
const THUMBNAIL_URL = "/Content/Images/HP3/video/overview-thumbnail.jpg";

interface OverviewVideoPlayerProps {
   label?: string;
}

const OverviewVideoPlayer: React.FC<OverviewVideoPlayerProps> = ({ label = "Watch the 1-min overview" }) => {
   // The YouTube player loads only after the visitor presses play on the thumbnail
   const [isPlaying, setIsPlaying] = useState(false);

   return (
      <div className="overview-video-frame">
         {isPlaying
            ? <iframe
               className="overview-video-iframe"
               src={EMBED_URL}
               title={VIDEO_TITLE}
               allow="accelerometer; autoplay; clipboard-write; encrypted-media; picture-in-picture; fullscreen"
               allowFullScreen
            />
            : <button type="button" className="overview-video-poster" onClick={() => setIsPlaying(true)} aria-label={`Play: ${VIDEO_TITLE}`}>
               <img className="overview-video-poster-img" src={CDNHelper.getUrl(THUMBNAIL_URL)} alt="" width={1680} height={945} />
               <span className="overview-video-play" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5.5v13l11-6.5-11-6.5Z" /></svg>
               </span>
               <span className="overview-video-label">{label}</span>
            </button>}
      </div>
   );
};

export default OverviewVideoPlayer;
